


































































































































































































































































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import FrekuensiNadi from "@/components/pemeriksaan/assesmen/FrekuensiNadi.vue";
import FrekuensiNafas from "@/components/pemeriksaan/assesmen/FrekuensiNafas.vue";
import SaturasiOksigen from "@/components/pemeriksaan/assesmen/SaturasiOksigen.vue";
import SuhuBadan from "@/components/pemeriksaan/assesmen/SuhuBadan.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarahNew.vue";
import { Tensi, TTV } from "@/types/asesmen";
import TandaVital from "@/services/TandaVital";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import { storePerawat } from "@/store/modules/perawat";
import AsesmenNyeri from "@/components/pemeriksaan/assesmen/AsesmenNyeri.vue";
import KesadaranGCSInput from "./KesadaranGCSInput.vue";
import { KesadaranGCS } from "@/types";
import { intervensiEwsOptions } from "@/utility/DataReferensi";

@Component({
  components: {
    TekananDarah,
    FrekuensiNadi,
    FrekuensiNafas,
    SuhuBadan,
    SaturasiOksigen,
    KesadaranGCSInput,
    AsesmenNyeri
  }
})
export default class TandaVitalEwsInput extends Vue {
  @Prop() readonly value;
  @Prop() readonly register;
  @Prop() readonly pasienRm;
  @Prop() readonly assignedId;
  @Prop({ default: null }) data;
  @Prop({ default: "normal" }) readonly mode: "normal" | "attach";
  @Prop() saveInput = false;

  @Ref() readonly dateTimePicker;
  @Ref() readonly refNyeri: AsesmenNyeri;
  @Ref() readonly refTensi: TekananDarah;
  @Ref() readonly refNadi: FrekuensiNadi;

  get isAttachMode() {
    return this.mode === "attach";
  }

  sistole = null;
  diastole = null;
  nadi = null;
  nafas = null;
  suhu = null;
  saturasiO2 = null;
  keadaanUmum = null;
  kesadaran = null;
  id = null;
  // examinedAt: string | Date = moment().format("YYYY-MM-DD HH:mm:ss");
  examinedAt: string | Date = new Date();
  user: number | string = null;
  hentiJantung = "n";
  periksaTensi = null;
  suplemeno2 = null;
  suplemeno2Satuan = "lt/mnt";
  suplemeno2SatuanOptions = [
    { text: "lt/mnt", value: "lt/mnt" },
    { text: "%", value: "%" }
  ];
  gds = null;
  urinOutput = null;
  urinOutputSatuan = "cc";
  urinOutputSatuanOptions = [
    { text: "cc", value: "cc" },
    { text: "cc/jam", value: "cc/jam" }
  ];

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  todayDate = moment().format("YYYY-MM-DD");
  ewsSkor = null;
  ewsRisiko = null;
  ewsCategory = null;
  saveNyeri = false;

  nyeri = null;
  stateNadi = null;
  sianosis = null;
  retraksi = null;
  proteinuria = null;
  lochea = null;
  nyeriPersalinan = null;
  tfu = null;
  kapiler = null;
  gcs: KesadaranGCS = null;
  nyeriSaveResponse = null;

  saving = false;
  loading = false;
  nyeriId = null;

  set tensi(val: Tensi) {
    this.sistole = val.sistole;
    this.diastole = val.diastole;
  }

  get tensi(): Tensi {
    return {
      sistole: this.sistole,
      diastole: this.diastole
    };
  }

  get ttv(): TTV {
    return {
      sistole: this.sistole,
      diastole: this.diastole,
      nadi: this.nadi,
      nafas: this.nafas,
      suhu: this.suhu,
      saturasiO2: this.saturasiO2,
      keadaanUmum: this.keadaanUmum,
      kesadaran: this.kesadaran
    };
  }

  set ttv(val: TTV) {
    this.setTensi({
      sistole: val.sistole,
      diastole: val.diastole
    });
    this.setFrekNadi(val.nadi);
    this.setFrekNafas(val.nafas);
    this.setSuhu(val.suhu);
    this.setSaturasiO2(val.saturasiO2);
    this.setKeadaanUmum(val.keadaanUmum);
    this.setKesadaran(val.kesadaran);
  }

  get listUser() {
    return storePerawat.listKaryawan;
  }

  get kesadaranOptions() {
    return [
      {
        id: "cm",
        name: "Compos Mentis"
      },
      {
        id: "apatis",
        name: "Apatis"
      },
      {
        id: "delirium",
        name: "Delirium"
      },
      {
        id: "somnolen",
        name: "Somnolen"
      },

      {
        id: "sopor",
        name: "Sopor"
      },
      {
        id: "semi-coma",
        name: "Semi Coma"
      },
      {
        id: "coma",
        name: "Coma"
      }
    ];
  }

  get kuOptions() {
    return [
      {
        id: "ringan",
        name: "Ringan"
      },
      {
        id: "sedang",
        name: "Sedang"
      },
      {
        id: "berat",
        name: "Berat"
      }
    ];
  }

  mounted() {
    this.changedId(this.assignedId);
  }

  @Watch("data")
  changedDataProp(val) {
    if (val) {
      this.periksaTensi = val.periksa_tensi;
      this.stateNadi = val.nadi;
      this.nadi = val.frekuensi_nadi;
      this.nafas = val.frekuensi_nafas;
      this.tensi = { sistole: val.sistole, diastole: val.diastole };
      this.suhu = val.suhu_badan;
      this.saturasiO2 = val.saturasi_oksigen;
    }
  }

  setTensi(val: Tensi) {
    this.tensi = {
      sistole: !val.sistole && val.sistole != 0 ? null : Number(val.sistole),
      diastole: !val.diastole && val.diastole != 0 ? null : Number(val.diastole)
    };
  }

  setFrekNadi(val) {
    this.nadi = !val && (val != 0 || val === null) ? null : Number(val);
  }

  setFrekNafas(val) {
    this.nafas = !val && val != 0 ? null : Number(val);
  }

  setSuhu(val) {
    this.suhu = !val && val != 0 ? null : Number(val);
  }

  setSaturasiO2(val) {
    this.saturasiO2 = !val && val != 0 ? null : Number(val);
  }

  setKeadaanUmum(val) {
    this.keadaanUmum = !val && val != 0 ? null : val;
  }

  setKesadaran(val) {
    this.kesadaran = !val && val != 0 ? null : val;
  }

  @Watch("ttv", { deep: true })
  changeTtv(val: TTV) {
    console.log("changeTtv", val);
    this.$emit("setValue", val);
  }

  @Watch("value", { deep: true })
  changeValue(val: TTV) {
    console.log("changeValue", val);
    this.ttv = val;
  }

  @Watch("saveInput")
  changeSaveInput(val: boolean) {
    if (val) {
      this.save();
    }
  }

  @Watch("examinedAt")
  changeExaminedAt(val: string) {
    if (val) {
      this.nyeri
        ? (this.nyeri.examined_at = val)
        : (this.nyeri = { examined_at: val });
    }
  }

  @Watch("periksaTensi")
  changePeriksaTensi(val: string) {
    if (val == "1") {
      // focus ke tensi field
      this.refTensi.disabled = false;
      this.$nextTick(() => {
        this.refTensi.focus();
      });
    } else {
      this.refTensi.disabled = true;
    }
  }

  @Watch("stateNadi")
  changeStateNadi(val: string) {
    if (["r", "i"].includes(val)) {
      // focus ke tensi field
      this.refNadi.disabled = false;
      this.$nextTick(() => {
        this.refNadi.focus();
      });
    } else {
      this.$nextTick(() => {
        this.refNadi.disabled = true;
      });
    }
  }

  get params() {
    return {
      pasien_rm: this.pasienRm,
      register_id: this.register,
      unit_id: this.userStore.unit_id,
      sistole: this.sistole,
      diastole: this.diastole,
      frekuensi_nadi: this.nadi,
      frekuensi_nafas: this.nafas,
      suhu_badan: this.suhu,
      saturasi_oksigen: this.saturasiO2,
      keadaan_umum: this.keadaanUmum,
      kesadaran: this.kesadaran,
      user_id: this.userStore.id,
      waktu_periksa: moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss"),
      henti_jantung: this.hentiJantung,
      periksa_tensi: this.periksaTensi,
      suplemeno2: this.suplemeno2,
      suplemeno2_satuan: this.suplemeno2Satuan,
      gds: this.gds,
      urin_output: this.urinOutput,
      urin_output_satuan: this.urinOutputSatuan,
      nadi: this.stateNadi,
      sianosis: this.sianosis,
      retraksi: this.retraksi,
      kapiler: this.kapiler,
      proteinuria: this.proteinuria,
      lochea: this.lochea,
      nyeri_persalinan: this.nyeriPersalinan,
      tfu: this.tfu,
      gcs_e: this.gcs?.e,
      gcs_v: this.gcs?.v,
      gcs_m: this.gcs?.m,
      ews_cat: this.ewsCategory,
      nyeri_id: this.nyeriId
    };
  }

  get userStore() {
    return userModule.user;
  }

  async save() {
    if (this.refNyeri.metode) {
      if (!this.saving) {
        this.saving = true;
        let nyeri = null;

        try {
          nyeri = await this.refNyeri.simpan();

          this.nyeriId = nyeri?.data ? nyeri.data?.id : null;
        } catch (err) {
          // alert(err.message);
          console.log(err);
        } finally {
          this.saving = false;
        }

        if (nyeri && nyeri.status == 1) {
          const saveTtv = await this.saveTtv();

          return saveTtv;
        }
      }
    } else {
      const saveTtv = await this.saveTtv();

      return saveTtv;
    }
  }

  async saveTtv() {
    if (!this.saving) {
      this.saving = true;

      let endSave = null;

      const save = (await this.id)
        ? TandaVital.update(this.id, this.params)
        : TandaVital.create(this.params);

      save
        .then(resp => {
          console.log("saved... attached mode", this.isAttachMode);
          if (!this.isAttachMode) {
            // close
            // this.close();
          }

          if (resp.status) {
            // toast success
            appModule.NoticeDelay("Berhasil menyimpan data!");

            this.$emit("saved");

            this.id = resp.data?.id;
            this.ewsSkor = resp.data?.ews_skor;
            this.ewsRisiko = resp.data?.ews_level;
          } else {
            endSave = {
              status: false,
              id: this.id
            };
          }

          console.log("return response save ttv", resp);

          return resp;
        })
        .catch(err => {
          console.log(err);
          endSave = {
            status: false,
            id: this.id
          };

          return Promise.reject(err);
        })
        .finally(() => {
          this.saving = false;
          this.$emit("end-save", endSave);
        });

      console.log("return save ttv");
      return save;
    }
  }

  clearInput() {
    this.id = null;
    this.sistole = null;
    this.diastole = null;
    this.nadi = null;
    this.nafas = null;
    this.suhu = null;
    this.saturasiO2 = null;
    this.keadaanUmum = null;
    this.kesadaran = null;
    this.examinedAt = new Date();
    this.user = null;
    this.hentiJantung = "n";
    this.periksaTensi = null;
    this.suplemeno2 = null;
    this.suplemeno2Satuan = "lt/mnt";
    this.gds = null;
    this.urinOutput = null;
    this.urinOutputSatuan = "cc";
    this.stateNadi = null;
    this.sianosis = null;
    this.retraksi = null;
    this.kapiler = null;
    this.proteinuria = null;
    this.lochea = null;
    this.nyeriPersalinan = null;
    this.tfu = null;
    this.gcs = null;
    this.ewsSkor = null;
    this.ewsRisiko = null;
    this.ewsCategory = null;
    this.nyeri = null;
    this.nyeriId = null;
    this.nyeriSaveResponse = null;
  }

  getDataById(id) {
    this.loading = true;

    console.log("get data by id = ", id);

    TandaVital.find(id)
      .then(resp => {
        const data = resp.data;

        this.id = data.id;
        this.sistole = data.sistole;
        this.diastole = data.diastole;
        this.nadi = data.frekuensi_nadi;
        this.nafas = data.frekuensi_nafas;
        this.suhu = data.suhu_badan;
        this.saturasiO2 = data.saturasi_oksigen;
        this.keadaanUmum = data.keadaan_umum;
        this.kesadaran = data.kesadaran;
        this.examinedAt = new Date(data.waktu_periksa);
        this.user = parseInt(data.user_id);
        this.hentiJantung = data.henti_jantung;
        this.periksaTensi = data.periksa_tensi;
        this.suplemeno2 = data.suplemeno2;
        this.suplemeno2Satuan = data.suplemeno2_satuan || "lt/mnt";
        this.gds = data.gds;
        this.urinOutput = data.urin_output;
        this.urinOutputSatuan = data.urin_output_satuan || "cc";
        this.stateNadi = data.nadi;
        this.sianosis = data.sianosis;
        this.retraksi = data.retraksi;
        this.kapiler = data.kapiler;
        this.proteinuria = data.proteinuria;
        this.lochea = data.lochea;
        this.nyeriPersalinan = data.nyeri_persalinan;
        this.tfu = data.tfu;
        this.gcs = {
          e: data.gcs_e,
          v: data.gcs_v,
          m: data.gcs_m
        };
        this.nyeriId = data.nyeri_id;
        this.nyeri = data.nyeri;
        this.ewsSkor = data.ews_skor;
        this.ewsRisiko = data.ews_level;
        this.ewsCategory = data.ews_cat;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @Watch("assignedId")
  changedId(val, oldVal = null) {
    console.log("watch assigned id", val, oldVal);

    if (!val) {
      // this.clearInput();
    } else if (val) {
      this.getDataById(val);
    }
  }

  close() {
    this.$emit("close");
    this.clearInput();
  }

  setNyeri(val) {
    this.nyeri = val;
  }

  clearNyeri() {
    this.nyeri = null;
  }

  setNyeriSaveResponse(val) {
    this.nyeriSaveResponse = val;
  }

  get stateNadiOptions() {
    return [
      {
        id: "r",
        name: "Reguler"
      },
      {
        id: "i",
        name: "Ireguler"
      },
      {
        id: "n",
        name: "Tidak Teraba"
      }
    ];
  }

  get sianosisOptions() {
    return [
      {
        id: "1",
        name: "Kemerahan"
      },
      {
        id: "2",
        name: "Pucat"
      },
      {
        id: "3",
        name: "Sianosis"
      },
      {
        id: "4",
        name: "Sianosis dan Motlet"
      }
    ];
  }

  get retraksiOptions() {
    return [
      {
        id: "y",
        name: "Ada"
      },
      {
        id: "n",
        name: "Tidak ada"
      }
    ];
  }

  get proteinuriaOptions() {
    return [
      {
        id: "1",
        name: "+/trace"
      },
      {
        id: "2",
        name: ">= ++"
      },
      {
        id: "x",
        name: "X"
      }
    ];
  }

  get locheaOptions() {
    return [
      {
        id: "n",
        name: "Normal"
      },
      {
        id: "a",
        name: "Abnormal"
      },
      {
        id: "x",
        name: "X"
      }
    ];
  }

  get nyeriPersalinanOptions() {
    return [
      {
        id: "n",
        name: "Normal"
      },
      {
        id: "a",
        name: "Abnormal"
      },
      {
        id: "x",
        name: "X"
      }
    ];
  }

  get rekomendasiEWS() {
    if (this.ewsCategory) {
      return intervensiEwsOptions.find(it => {
        return this.ewsRisiko == it.level;
      });
    } else {
      return null;
    }
  }

  @Watch("nyeriSaveResponse")
  changedNyeriSaveResponse(val, oldVal = null) {
    if (val.status) {
      this.saveTtv();
    }
  }

  setKesadaranLevel(val: { maxVal: number; id: string; text: string }) {
    this.kesadaran = val?.id ?? null;
  }

  setKesadaranGCS(val: KesadaranGCS) {
    this.gcs = val;
  }

  nyeriSaveEnd(val: { status: boolean; id: number | null }) {
    this.nyeriSaveResponse = val;
    this.saveNyeri = false;
  }
}
